import React from 'react';
import styles from './WorkingConditions.module.css';
import safetyImage from '../../../assets/images/safety.jpg';  // ваш путь к картинке

function WorkingConditions() {
  return (
    <div className={styles.outerWrapper}>
      {/* Жёлтая полоса */}
      <div className={styles.yellowStrip}>
        <div className={styles.innerContainer}>
          <h1 className={styles.mainTitle}>Условия труда</h1>
        </div>
      </div>

      {/* Основной контент */}
      <div className={styles.content}>
        <h2 className={styles.subTitle}>Специальная оценка условий труда</h2>

        <div className={styles.contentWrapper}>
          <div className={styles.textBox}>
            <p className={styles.paragraph}>
              Сохранение жизни и здоровья работников – является приоритетом ООО «Восток Гелиос».
              Для достижения этой цели реализуются программы по безопасности труда, в том числе
              проводится специальная оценка условий труда (СОУТ). Информация о результатах
              проведения СОУТ представлена в соответствии со статьей 15 Федерального закона
              Российской Федерации от 28.12.2013 №426-ФЗ «О специальной оценке условий труда».
            </p>
          </div>
          <div className={styles.imageColumn}>
            <img src={safetyImage} alt="Охрана труда" className={styles.image} />
          </div>
        </div>

        <div className={styles.buttonWrapper}>
          <a
            href="https://disk.yandex.ru/d/KuzhDV1z1g2z8w"  // ← ЯДиск
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
          >
            Подробнее о СОУТ
          </a>
        </div>
      </div>
    </div>
  );
}

export default WorkingConditions;